import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { LabsPageComponent } from './Labs.page.component';
import {
  getLabRoot,
  getLabCategoryById,
  getLabCategoriesById,
} from 'shared/store/selectors/lab.selector';
import { getSelectedWorkspace } from 'shared/store/selectors/workspace.selector';

const mapStateToProps = ({ lab, workspace }, ownProps) => {
  let category;
  let { id } = ownProps;
  let isRoot = false;

  if (id) {
    category = getLabCategoryById(lab, { id });
  } else {
    category = getLabRoot(lab);
    id = category.id;
    isRoot = true;
  }

  return {
    id,
    category,
    isRoot,
    workspaceName: getSelectedWorkspace({ workspace })?.name,
    showBreadcrumbs: !isRoot,
    children: getLabCategoriesById(lab, id),
    isReady: lab.isReady,
  };
};

const ConnectedLabsPage = connect(mapStateToProps, {})(LabsPageComponent);

export const LabsPage = () => {
  const params = useParams();
  return <ConnectedLabsPage {...params} />;
};
